import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/contractor-profile.png'


const _withScopeId = n => (_pushScopeId("data-v-1b0b167f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Phase # notes", -1))
const _hoisted_3 = {
  key: 0,
  class: "alert-box"
}
const _hoisted_4 = { class: "modal__content" }
const _hoisted_5 = { class: "contract_assign_modal_item_title" }
const _hoisted_6 = { class: "contract_assign_modal_tag" }
const _hoisted_7 = { class: "contract_assign_modal_item_content" }
const _hoisted_8 = { class: "contract_assign_modal_info_header" }
const _hoisted_9 = { class: "contract_assign_modal_info_actions" }
const _hoisted_10 = { class: "contract_assign_modal_info_footer" }
const _hoisted_11 = { class: "contract_assign_modal_info_author" }
const _hoisted_12 = { class: "contract_assign_modal_info_author_image" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_15 = { class: "contract_assign_modal_info_date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_ConfirmPhaseTaskDeleteModal = _resolveComponent("ConfirmPhaseTaskDeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonDialog, {
      modelValue: $setup.onCloseModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.onCloseModal) = $event)),
      isShowHeader: false,
      isShowBackButton: false,
      width: "848px",
      "max-width": "100%",
      persistent: "",
      className: ['contract_assign_modal']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          ($props.message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.message), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            class: "close__icon",
            onClick: $setup.onCloseModal
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          ($setup.phaseTasks.length)
            ? (_openBlock(), _createBlock(_component_v_expansion_panels, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.phaseTasks, (task, index) => {
                    return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                      key: task.id
                    }, {
                      default: _withCtx(() => [
                        (task?.phaseNotes?.length)
                          ? (_openBlock(), _createBlock(_component_v_expansion_panel_title, { key: 0 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createElementVNode("h2", null, "Note " + _toDisplayString(index + 1), 1),
                                  _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("p", null, _toDisplayString(task.name), 1)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (task?.phaseNotes?.length)
                          ? (_openBlock(), _createBlock(_component_v_expansion_panel_text, { key: 1 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.phaseNotes, (notes) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "contract_assign_modal_info",
                                      key: notes?.id
                                    }, [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("p", null, _toDisplayString(notes?.note), 1),
                                        _createElementVNode("div", _hoisted_9, [
                                          (!$setup.isPropertyOwner)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                icon: "mdi-pencil",
                                                class: "action-icon",
                                                onClick: ($event: any) => ($setup.onEditNote(notes))
                                              }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (!$setup.isPropertyOwner)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                icon: "mdi-delete",
                                                class: "action-icon",
                                                onClick: ($event: any) => ($setup.toggleShowDeleteModal(notes))
                                              }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                          _createElementVNode("div", _hoisted_12, [
                                            (notes?.user?.profileImageUrl)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: notes?.user?.profileImageUrl,
                                                  alt: ""
                                                }, null, 8, _hoisted_13))
                                              : (_openBlock(), _createElementBlock("img", _hoisted_14))
                                          ]),
                                          _createElementVNode("p", null, _toDisplayString(notes?.user
                            ? `${notes.user.firstName} ${notes.user.lastName}`
                            : "Toby Sparks"), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("p", null, _toDisplayString($setup.formatDate(notes?.dateCreated)), 1)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["contract_assign_modal_footer", { 'show-add-btn': $props.isShowAddNoteBtn }])
        }, [
          ($props.isShowAddNoteBtn)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "+Add Note",
                variant: "elevated",
                class: "button button-orange",
                onClick: $setup.onAddNote
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            label: "Cancel",
            variant: "elevated",
            class: "button button-purple-border",
            onClick: $setup.onCloseModal
          }, null, 8, ["onClick"])
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.isShowDeleteModal)
      ? (_openBlock(), _createBlock(_component_ConfirmPhaseTaskDeleteModal, {
          key: 0,
          message: "Are you sure you would like to delete this Task note?",
          onOnClose: $setup.toggleShowDeleteModal,
          onOnConfirm: $setup.onDeleteNote,
          Loadingvalue: $setup.Loading
        }, null, 8, ["onOnClose", "onOnConfirm", "Loadingvalue"]))
      : _createCommentVNode("", true)
  ], 64))
}